import React, { Component } from 'react';
//import moment from 'moment';
import { Link } from 'react-router-dom';
import Table from './common/table';
import auth from '../services/authService';

const $ = require('jquery');
$.DataTable = require('datatables.net');

class TradeResponsesTable extends Component {
  columns = [
    {
      path: 'name',
      label: 'Name',
    },
    // {
    //   path: 'created_at',
    //   label: 'Created Date',
    //   content: (tresponse) =>
    //     moment(tresponse.created_at).startOf('day').format('LL'),
    // },
    {
      key: (tresponse) => `${tresponse._id}-s`,
      label: 'Info',
      content: (tresponse) => (
        <Link
          to={`/trade-responses/${tresponse._id}`}
          className="btn btn-primary btn-sm"
        >
          View
        </Link>
      ),
    },
  ];

  deleteColumn = {
    key: 'delete',
    label: 'Delete',
    content: (tresponse) => (
      <button
        onClick={() => this.props.onDelete(tresponse)}
        className="btn btn-danger btn-sm"
      >
        Delete
      </button>
    ),
  };

  editColumn = {
    key: 'edit',
    label: 'Edit',
    content: (tresponse) => (
      <Link
        to={`/trade-responses/edit/${tresponse._id}`}
        className="btn btn-custom btn-sm"
      >
        Edit
      </Link>
    ),
  };

  constructor() {
    super();
    const user = auth.getCurrentUser();
    if (user && user.isAdmin) {
      this.columns.push(this.editColumn);
      this.columns.push(this.deleteColumn);
    }
  }

  componentDidMount() {
    $(document).ready(function () {
      $('#dataTable').DataTable();
    });
  }

  render() {
    const { tresponses, message } = this.props;
    return <Table columns={this.columns} data={tresponses} message={message} />;
  }
}

export default TradeResponsesTable;
